import React from 'react';

export default function MeanStack() {
  return (
    <>
      <section className="container-wrapper">
    <h2>MEAN - Full Stack</h2>
    <p>The MEAN Full Stack Development program is designed to equip learners with the skills to build modern, scalable, and responsive web applications using <strong>MongoDB, Express, Angular and Node</strong>. Starting with the fundamentals of HTML, CSS, JavaScript and Typescript learners progress through front-end development, back-end APIs, databases, and full-stack integration.</p>
  <p>This course blends <strong>theory, hands-on coding, and real-world projects</strong>, preparing participants to work confidently as full-stack developers.</p>

  <h2>Course Duration</h2>
  <h3>3 Months (12 Weeks)</h3>
  <ul className="course-desc">
    <li><strong>Mode:</strong> Online</li>
    <li><strong>Format:</strong> Lectures, Coding Tests, Assignments, and Projects</li>
    <li><strong>Pre-requisites:</strong> Basic computer knowledge, logical thinking. No prior coding experience required.</li>
  </ul>

    <h2 className='mt-30'>Learning Objectives</h2>
    <p>By the end of this course, participants will:</p>
    <ul className="course-list">
      <li>Understand web development fundamentals with <strong>HTML, CSS, and JavaScript</strong>.</li>
      <li>Build interactive and responsive front-end applications using <strong>Angular</strong>.</li>
      <li>Develop scalable back-end APIs with <strong>Node.js and Express.js</strong>.</li>
      <li>Design and manage NoSQL databases with <strong>MongoDB</strong>.</li>
      <li>Integrate front-end and back-end into <strong>full-stack applications</strong>.</li>
      <li>Work with <strong>Git, GitHub</strong>, and follow industry-standard development work flows.</li>
      <li>Deploy applications on cloud platforms <strong>(AWS, Github)</strong>.</li>
    </ul>

    <h3 className='mt-20'>Who Should Attend</h3>
    <ul className="course-list">
      <li>Beginners wanting to start a career in web development</li>
      <li>Students and graduates aiming for software jobs</li>
      <li>Professionals looking to upskill in full-stack development</li>
    </ul>

    <h3 className='mt-20'>Career Opportunities</h3>
    <p>After completing this course, learners can apply for roles such as:</p>
    <ul className="course-list">
      <li>Frontend Developer (Angular)</li>
      <li>Backend Developer (Node.js/Express.js)</li>
      <li>Full Stack Developer (MERN)</li>
      <li>JavaScript Developer</li>
      <li>Web Application Developer</li>
    </ul>

    <h2 className='mt-30'>Course Modules</h2>
    <h3>Module 1: Web Development Fundamentals (Week 1–2)</h3>
    <ul className="course-list">
      <li>Introduction to Web Development</li>
      <li>HTML5: Structure, Forms, Semantic Tags</li>
      <li>CSS3: Styling, Flexbox, Grid, Animations</li>
      <li>Responsive Web Design (Media Queries, Mobile-first Design)</li>
      <li>JavaScript Basics: Variables, Data Types, Functions, DOM Manipulation</li>
      <li>Typescript Basics</li>
      <li>Mini Project: Portfolio Website</li>
    </ul>

    <h3 className='mt-20'>Module 2: Advanced JavaScript & ES6+ (Week 3)</h3>
    <ul className="course-list">
      <li>ES6+ Features: Let/Const, Arrow Functions, Spread/Rest, Template Literals</li>
      <li>Objects, Arrays, Iteration Methods (map, filter, reduce)</li>
      <li>Event Handling & Form Validation</li>
      <li>Promises, async/await, Fetch API</li>
      <li>Mini Project: Blog App using Fetch API</li>
    </ul>

    <h3 className='mt-20'>Module 3: Angular – Frontend Development (Week 4–6)</h3>
    <ul className="course-list">
      <li>Introduction to Angular & Angular CLI & project setup</li>
      <li>Components, templates & styling</li>
      <li>Data binding (Interpolation, Property, Event, Two-way binding)</li>
      <li>Directives (ngIf, ngFor, ngSwitch, custom directives)</li>
      <li>Services & Dependency Injection</li>
      <li>Angular Routing & Navigation</li>
      <li>Forms (Template-driven & Reactive)</li>
      <li>Pipes & Custom Pipes</li>
      <li>Consuming REST APIs in Angular using HttpClient</li>
      <li>Observables & RxJS basics</li>
      <li>Angular services for API integration</li>
      <li>Lifecycle Hooks in Angular</li>
      <li>Mini Project: Angular CRUD App (with mock data)</li>
    </ul>

    <h3 className='mt-20'>Module 4: Node.js & Express.js – Backend Development (Week 7-8)</h3>
    <ul className="course-list">
      <li>Node.js Basics: Modules, NPM, Event Loop</li>
      <li>Express.js Framework: Routing, Middleware</li>
      <li>RESTful API Development</li>
      <li>Authentication & Authorization (JWT, bcrypt)</li>
      <li>Error Handling & Validation</li>
      <li>Mini Project: REST API for User Management</li>
    </ul>

    <h3 className='mt-20'>Module 5: MongoDB – Database (Week 9)</h3>
    <ul className="course-list">
      <li>Introduction to NoSQL & MongoDB</li>
      <li>CRUD Operations in MongoDB</li>
      <li>Mongoose ODM (Schemas, Models, Validation)</li>
      <li>Data Relationships (One-to-Many, Many-to-Many)</li>
      <li>Aggregation Framework</li>
      <li>Mini Project: Product Catalog API with MongoDB</li>
    </ul>


    <h3 className='mt-20'>Module 6: Full Stack Integration (Week 10-11)</h3>
    <ul className="course-list">
      <li>Connecting Angular Frontend with Node.js Backend</li>
      <li>Authentication flow (Login/Signup with JWT)</li>
      <li>CRUD operations from frontend to backend</li>
      <li>File uploads (Multer)</li>
      <li>Mini Project: Blogging Platform (Full Stack)</li>
    </ul>


    <h3 className='mt-20'>Module 7: Deployment & Version Control (Week 12)</h3>
    <ul className="course-list">
      <li>Git & GitHub (Version Control, Branching, Pull Requests)</li>
      <li>Deployment: AWS</li>
      <li>Final Project Presentation</li>
      <li>Data Relationships (One-to-Many, Many-to-Many)</li>
      <li>Aggregation Framework</li>
      <li>Mini Project: Product Catalog API with MongoDB</li>
    </ul>    
  </section>
  </>
  );
}







